/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Logintoreview3Inputs */

const id_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk mengulas`)
};

const ms_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk mengulas`)
};

const da_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind for at anmelde`)
};

const de_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden zum Bewerten`)
};

const en_us2_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login to review`)
};

const es_es2_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para reseñar`)
};

const es_mx2_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para reseñar`)
};

const fil_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-login para mag-review`)
};

const fr_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour laisser un avis`)
};

const it_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per recensire`)
};

const hu_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelentkezz be az értékeléshez`)
};

const nl_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen om te reviewen`)
};

const no_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn for å omtale`)
};

const pl_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby dodać recenzję`)
};

const pt_br2_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça login para revisar`)
};

const pt_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sessão para avaliar`)
};

const ro_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentifică-te pentru a recenza`)
};

const fi_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään arvostellaksesi`)
};

const sv_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in för att recensera`)
};

const vi_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để đánh giá`)
};

const tr_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorum yapmak için giriş yapın`)
};

const cs_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro napsání recenze se přihlaste`)
};

const bg_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Влезте, за да ревюирате`)
};

const ru_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы написать обзор`)
};

const uk_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть, щоб залишити відгук`)
};

const ar_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل الدخول للمراجعة`)
};

const hi_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा करने के लिए लॉगिन करें`)
};

const th_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบเพื่อเขียนรีวิว`)
};

const ja_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログインしてレビュー`)
};

const zh_cn2_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录以发表评论`)
};

const zh_hant1_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入以發表評論`)
};

const ko_offerdetail_reviews_logintoreview3 = /** @type {(inputs: Offerdetail_Reviews_Logintoreview3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인하여 리뷰 작성`)
};

/**
* | output |
* | --- |
* | "Login to review" |
*
* @param {Offerdetail_Reviews_Logintoreview3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_logintoreview3 = /** @type {((inputs?: Offerdetail_Reviews_Logintoreview3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Logintoreview3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "da") return da_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "de") return de_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "it") return it_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "no") return no_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "th") return th_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_logintoreview3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_logintoreview3(inputs)
	return ko_offerdetail_reviews_logintoreview3(inputs)
});
export { offerdetail_reviews_logintoreview3 as "offerDetail.reviews.loginToReview" }